import { LabelInValueType } from "rc-select/lib/Select";

export const formatCategories = (fieldName: string, categories: LabelInValueType[]): Record<string, string> =>
  categories?.reduce((acc, { value, label }) => ({
    ...acc,
    [`${fieldName}-${value}`]: label
  }), {});
